<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" md="3">
        <div >
          <v-select
          :items="lgasAll"
          :disabled='$root.isLga'
          ref='lgaSelector'
          item-text="name"
          v-model='selectedLga'
          :label="(selectedLga) ? selectedLga : 'LGA' "
          outlined
          dense
        >
        <template v-slot:prepend-item>
        <v-list-item
          ripple
          class='link'
          @click='selectedLga = "All LGAs";close2()'
        >
        All LGAS
        </v-list-item>
         </template>
        </v-select>
        </div>
      </v-col>
       <v-col cols="12" md="3" >
        <div >
          <v-select
          ref='proSelector'
          :items="programsSet"
          item-text="Program Name"
          v-model='selectedProgram'
          :label="(selectedProgram) ? selectedProgram['Program Name'] : 'Select Program' "
          outlined
          dense
        >
         <template v-slot:prepend-item>
        <v-list-item
          ripple
          class='link'
          @click='selectedProgram = null;close()'
        >
        All Programs
        </v-list-item>
         </template>
        </v-select>
        </div>
      </v-col>
       <v-col cols="12" md="3">
        <div >
          <v-select
          ref='yearSelector'
          :items="$root.yearRanges"
          item-text="name"
          v-model='selectedRange'
          :label="(selectedRange) ? selectedRange : 'All Years'"
          outlined
          dense
        >
        <template v-slot:prepend-item>
        <v-list-item
          ripple
          class='link'
          @click='selectedRange = null;close3()'
        >
        All Years
        </v-list-item>
         </template>
        </v-select>
        </div>
      </v-col>
      <v-col cols="12" md='2' >
        <div >
          <v-select
          :items='months'
           item-text="name"
          item-value="value"
          v-model='selectedMonth'
          :label="(selectedMonth) ? showMonth(selectedMonth) : 'Select Month' "
          dense
          outlined
        ></v-select>
        </div>
      </v-col> 
      <v-col cols='12' md='1'>
        <v-btn color='success' @click='reset'>Reset </v-btn>
      </v-col>
      
      <v-col cols="12" lg="6">
        <TotalAttendance :totalAttendance='totalAttendance' ></TotalAttendance>
      </v-col>
      <v-col cols="12" lg="6">
        <ProgramsLogged :count='filtered.length' title='Programs Logged'></ProgramsLogged>
      </v-col>
      <!-- <v-col cols="12" lg="4">
        <ProgramsListed :selectedLga='selectedLga' :selectedMonth='selectedMonth' title='Programs Listed'></ProgramsListed>
      </v-col> -->
      <v-col cols="12" sm="12" lg="12" v-if='elementVisible'>
        <TheNewsletterCampaign :submissions='filtered' ></TheNewsletterCampaign>
      </v-col>
      <v-col cols="12" sm="12" lg="12" v-else>
        <p class="text-center">Loading Chart....</p>
      </v-col>
      <v-col cols="12" class="py-0" v-if='showBars'>
        <TheProgramsList :lga='selectedLga' :month='showMonth(selectedMonth)' :submissions='filtered' :showFilter='false'></TheProgramsList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
export default {
  name: "MoveItNQ",
  data: () => ({
    months:[{name:"All", value:-1},{value:6,name:"July"}, {value:7,name:"August"},{value:8,name: "September"},
    {value:9,name: "October"}, {value:10,name:"November"}, {value:11,name:"December"},{value:0,name:"January"},
    {value:1,name: "February"}, {value:2,name:"March" }, {value:3,name:"April"}, {value:4,name:"May"},{value:5,name: "June"}],
    selectedRange:null,
    selectedProgram:null,
    elementVisible:false,
    showBars:true,
    selectedLga:"All LGAs",
    selectedMonth:-1,
    page: {
      title: "Move It NQ"
    },
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: true,
        to: "#"
      },
      {
        text: "Classic",
        disabled: true
      }
    ]
  }),
  // watch: {
  //   selectedLga () {
  //     this.$root.selectedLga = this.selectedLga
  //   },
  //   selectedMonth () {
  //     this.$root.selectedMonth = this.selectedMonth
  //   },
  //   selectedRange () {
  //     this.$root.selectedRange = this.selectedRange
  //   },
  // },
  mounted() {
    if(this.$root.isLga){
      this.selectedLga = this.$root.user.LGA
    }else{
        //nothing
    }
    // this.selectedRange = this.$root.selectedRange
    setTimeout(() => (this.elementVisible = true), 2000);
    
  },
  computed:{
    ...mapState(['lgasAll','programs','submissions','programsSort']),
    filtered() {
      let countableLga = [];
      //LGA filter
      this.submissions.forEach(element => {
        if(this.selectedLga !== "All LGAs")
        { 
          (this.selectedLga === element.LGA) ? countableLga.push(element) : ''
        }else{
          countableLga.push(element)
        }
      });
      let countablePro = [];
      countableLga.forEach(element => {
         if(this.selectedProgram !== null)
        { 
          (this.selectedProgram === element['Event Name']) ? countablePro.push(element) : ''
        }else{
          countablePro.push(element)
        }
      });
      let countableRange = [];
      countablePro.forEach(element => {
         if(this.selectedRange !== null)
        { 
          var str = this.selectedRange.split("/");
          let start = Number(str[0])
          let end = Number(str[1])
          let month = new Date(element.Date).getMonth();
          let year = new Date(element.Date).getFullYear();
          (year == start && month > 5) ? countableRange.push(element) : '';
          (year == end && month < 6) ? countableRange.push(element) : '';
          }
          else{
          countableRange.push(element)
          }
      });
      let countableMonth = [];
       countableRange.forEach(element => {
         if(this.selectedMonth > -1)
          { 
            let month = new Date(element.Date).getMonth();
            if(month === this.selectedMonth) countableMonth.push(element)
          }
          else{
            countableMonth.push(element)
          }
      });
      return countableMonth;
     
    },
    totalAttendance() {
      let at = 0;
      this.filtered.forEach(element => { at = at + Number(element.Attendance) });
      return at;
    },
    pLogged() {
      let count = 0;
      let lgas = [];
      this.filtered.forEach(element => { lgas.push(element.LGA) });
      lgas = [...new Set(lgas)];
      this.submissions.forEach(element => {
        if(lgas.includes(element.LGA)) count++;
      })
      return count;
    },
    programsSet() {
      let data = [];
      this.submissions.forEach(element => {
        if(element.LGA === this.selectedLga) data.push(element['Event Name'])
      });
      return data;
  },
  },
  methods:{
    close() {  this.$refs.proSelector.blur(); },
    close2() { this.$refs.lgaSelector.blur(); },
    close3() { this.$refs.yearSelector.blur(); },
    reset() {
    this.selectedRange = null;
    this.selectedProgram = null;
    this.selectedLga = "All LGAs";
    this.selectedMonth = -1;
    },
    showMonth(month)
    {
      this.months.forEach(element => {
        if(element.value === month) return String(element.name)
      });
    }
  },
  components: {
    TotalAttendance: () =>
      import(
        "@/views/dashboards/dashboardComponents/total-attendance/TotalAttendance"
      ),
    ProgramsLogged: () =>
      import(
        "@/views/dashboards/dashboardComponents/programs-logged/ProgramsLogged"
      ),
    // ProgramsListed: () =>
    //   import(
    //     "@/views/dashboards/dashboardComponents/programs-logged/ProgramsListed"
    //   ),
    TheNewsletterCampaign: () =>
      import(
        "@/views/dashboards/dashboardComponents/newsletter-campaign/TheNewsletterCampaign"
      ), 
    TheProgramsList: () =>
      import(
        "@/views/dashboards/dashboardComponents/programs-list/TheProgramsList"
      )
  }
};
</script>